import React, { useState, useEffect } from 'react';

// internal libaries
import { Screen, DateTime } from "_atoms";
import { BookingTable } from '_organisms';

// redux
import { useSelector, useDispatch } from 'react-redux';
import {  selectUserDb } from '_redux/slices/main-screen/user';
import {  selectBookingsHistoryStatus, getUserBookings, selectBookingsGrouped, selectAllBookings, getAllBookings } from '_redux/slices/assistance-bookings/bookings-history';
import { selectDate, setDate as setCalendarDate } from '_redux/slices/prm-bookings/calendar';

// bootstrap
import Spinner from 'react-bootstrap/Spinner' 
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

// styles
import { Colors, Spacing } from '_styles';

const EmptyScreen = () => {
    return (
        <Screen>
            <Row style={{ textAlign:'center', display:'flex', justifyContent:'center', marginTop:100}}>
                <p style={{opacity:0.7,  color:Colors.TEXT_COLOR }}>No Bookings</p>
            </Row>
        </Screen>
    )
}

const BookingHistoryList = () => {

    // get date string for indexing bookings by date
    const dateToDateString = (date) => {
        return date.toISOString().split('T')[0]
    }

    //#region redux and date states
    const dispatch = useDispatch();
    const bookingsHistory = useSelector(selectBookingsGrouped);
    const allBookingsHistory = useSelector(selectAllBookings)
    const status = useSelector(selectBookingsHistoryStatus);
    const calendarDate = useSelector(selectDate);
    const userDb = useSelector(selectUserDb);
    // booking-history
    // date states
    
    // table states
    const [tableType, setTableType] = useState('user')

    //#endregion

    const changeType = () => {
        if(tableType == 'user'){ setTableType('all-bookings')}
        else { setTableType('user')}
    }  

    // get all bookings
    useEffect(() => {
        dispatch(getUserBookings(calendarDate));
    }, []);

    // get date booking
    useEffect(() => {
        dispatch(getAllBookings(calendarDate));
    }, [calendarDate]);

    useEffect(() => {
        if(tableType == 'all-bookings'){
            // get all bookings for user
            dispatch(getAllBookings(calendarDate));
        }
    }, [tableType]);

    return (
        <>
            {/* Back Button & Title */}
            <Row>
                <Col xs={9}>
                    {
                        userDb.details.type == 'AIRPORT' ? <Button variant={ tableType == 'all-bookings' ? "primary" : 'outline-primary'} onClick={changeType}>{'All Bookings'}</Button> : ''
                    }       
                </Col>
                <Col>
                    {/* <DateTime date={travelAgent ? calendarDate : date} setDate={setDate} /> */}
                    <DateTime date={calendarDate} setDate={(date)=>{ dispatch(setCalendarDate(dateToDateString(date))) }} />
                </Col>
            </Row>
            {
                status == 'loading' ?
                    <div style={{textAlign:'center', marginTop:'15%'}}>
                        <Spinner
                            as="span"
                            animation="border"
                            size="xl"
                            role="status"
                            aria-hidden="true"
                            variant="primary"
                        />
                    </div>
                :
                <Row style={{marginBottom:Spacing.SCALE_32}} className='mt-3'>
                    {
                        (tableType == 'all-bookings') ?
                            <>
                                {
                                    allBookingsHistory && allBookingsHistory.length > 0 ?
                                    <BookingTable data={allBookingsHistory} /> 
                                    :
                                    <EmptyScreen />
                                }   
                            </>
                        :
                        (bookingsHistory && bookingsHistory[calendarDate] && bookingsHistory.length != 0) ?
                            <BookingTable data={bookingsHistory[calendarDate]} />
                        :                                    
                            <EmptyScreen />
                    }
                </Row>
            }
        </>
    );
}

export default BookingHistoryList;
